var scope_0 = require('/home/runner/work/collectif-ata.com/collectif-ata.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a43802678652090f032242411d285b4.js').default;
var scope_1 = require('/home/runner/work/collectif-ata.com/collectif-ata.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/52b5fed1e77136f26415af553b338d7e.js').default;
var scope_2 = require('/home/runner/work/collectif-ata.com/collectif-ata.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    